import { createContext } from 'react'

const AuthTrainingContext = createContext()

export default AuthTrainingContext
